<template>
  <v-container>
    <v-dialog v-model="dialog_value.show" max-width="700px"
              @click:outside="$store.commit('close_delete_cast_dialog')">
      <v-card>
        <v-toolbar flat color="error" dark class="justify-center">
          <v-toolbar-title>حذف عامل</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-2 pb-0">
          <v-row>
            <v-col>
              آیا از حذف
              <span class="red--text h5">
                {{ dialog_value.user.first_name }}
                {{ dialog_value.user.last_name }}
              </span>
              اطمینان دارید؟
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="$store.commit('close_delete_cast_dialog')">
            خیر
          </v-btn>
          <v-btn color="error" @click="$store.dispatch('delete_cast_admin',{id :dialog_value.user.id})">
            بله
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>

</template>

<script>
import {mapState} from "vuex";

export default {
  name: "DeleteCastDialogAdmin",
  computed: {
    ...mapState({
      dialog_value: state => state.Admin.settings.delete_cast_dialog
    }),
  },
}
</script>

<style scoped>

</style>